<template>
	<v-container>
		<v-form ref="locumQualificationsForm" v-model="valid" class="pa-4 pt-0 text-wrap">
			<v-row
				><v-col> <v-text-field v-model="qualification" :outlined="true" label="Primary Qualification" :rules="qualifactionRules"></v-text-field> </v-col
			></v-row>

			<v-row
				><v-col> <v-text-field v-model="collegeuniversity" :outlined="true" label="College/University" :rules="collegeuniversityRules"></v-text-field> </v-col
			></v-row>

			<v-row
				><v-col>
					<v-menu
						ref="qualificationYearMenu"
						v-model="qualificationYearMenu"
						pt-1
						:close-on-content-click="false"
						transition="scale-transition"
						offset-y
						max-width="320px"
						min-width="290px"
					>
						<template #activator="{ on }">
							<v-text-field
								v-model="dateFormatted"
								outlined
								class="pb-3"
								label="Date Qualified"
								persistent-hint
								hint="Select or type the date (DD/MM/YYYY)"
								:rules="yearqualifiedRules"
								@blur="setDate"
								v-on="on"
							></v-text-field>
						</template>
						<v-date-picker v-model="qualificationDate" :max="new Date().toISOString()" no-title @input="qualificationYearMenu = false"></v-date-picker>
					</v-menu> </v-col
			></v-row>

			<v-row
				><v-col>
					<v-text-field
						v-model="otherqualifications"
						:outlined="true"
						label="Other Qualifications"
						messages="(Optional) Additional qualifications, diplomas, courses, certificates"
					></v-text-field> </v-col
			></v-row>
		</v-form>
		<v-row v-if="solo">
			<v-btn text @click="reset">Clear</v-btn>
			<v-spacer></v-spacer>
			<v-btn class="white--text" color="deep-purple accent-4" depressed @click="SubmitForm()">Update</v-btn>
		</v-row>
	</v-container>
</template>

<script>
import { bus } from '@/main';
import axios from 'axios';
import store from '@/store';
import moment from 'moment';

function formatDate(date) {
	if (!date) return null;

	const [year, month, day] = date.split('-');
	return `${day}/${month}/${year}`;
}

export default {
	props: {
		solo: {
			type: Boolean,
			default: true,
		},
	},

	data: () => ({
		name: 'LocumQualificationsForm',
		valid: false,
		qualificationYearMenu: false,
		qualificationDate: null,
		dateFormatted: formatDate(new Date().toISOString().substr(0, 10)),

		qualification: 'qualifications' in store.getters.user ? store.getters.user.qualifications.qualification : null,
		qualifactionRules: [v => !!v || 'Required'],
		collegeuniversity: 'qualifications' in store.getters.user ? store.getters.user.qualifications.institution : null,
		collegeuniversityRules: [v => !!v || 'Required'],
		yearqualified: null,
		yearqualifiedRules: [
			v => !!v || 'Required',
			v => (v && moment(v, 'DD/MM/YYYY', true).isValid()) || 'Date is not valid, the date format should be DD/MM/YYYY',
			v => (v && moment(v, 'DD/MM/YYYY', true).isSameOrBefore(moment())) || 'Date can not be in the future',
		],
		otherqualifications: 'qualifications' in store.getters.user ? store.getters.user.qualifications.other_qualifications : null,
	}),

	computed: {
		user() {
			return store.getters.user;
		},
	},

	watch: {
		qualificationDate() {
			this.dateFormatted = this.formatDate(this.qualificationDate);
		},
	},

	mounted() {
		window.scrollTo(0, 0);

		/*
			[INFO]: We parse the date from the server from MM/DD/YYYY to DD/MM/YYYY and parse it back when sending it to the server.
			This will need be refactored when the server is updated with the correct format
		*/
		this.dateFormatted = 'qualifications' in store.getters.user ? this.formatDateFromServer(store.getters.user.qualifications.year_qualified) : null;
		this.qualificationDate = 'qualifications' in store.getters.user ? this.parseDateFromServerFormat(store.getters.user.qualifications.year_qualified) : null;

		if (this.solo) {
			bus.$on('intent:submit-forms:' + this.name, data => {
				let valid = this.validate();
				if (valid) {
					bus.$emit('update:spinning', true);
					this.postToBackend(data);
				} else {
					window.scrollTo(0, 0);
				}
			});
		} else {
			bus.$on('intent:submit-forms', data => {
				let valid = this.validate();
				if (valid) {
					bus.$emit('update:spinning', true);
					this.postToBackend(data);
				} else {
					window.scrollTo(0, 0);
				}
			});
		}
	},

	beforeDestroy() {
		bus.$off('intent:submit-forms');
		bus.$off('intent:submit-forms:' + this.name);
	},

	methods: {
		setDate() {
			this.qualificationDate = this.parseDate(this.dateFormatted);
		},

		handleImage(e) {
			const selectedImage = e;
			this.createBase64Image(selectedImage);
		},

		createBase64Image(fileObject) {
			const reader = new FileReader();

			reader.onload = e => {
				this.uploaded_image_base_64 = e.target.result;
			};

			reader.readAsDataURL(fileObject);
		},

		validate() {
			return this.$refs.locumQualificationsForm.validate();
		},

		reset() {
			this.$refs.locumQualificationsForm.reset();
		},

		resetValidation() {
			this.$refs.locumQualificationsForm.resetValidation();
		},

		async postToBackend() {
			const token = store.getters.jwtToken;

			const body = {
				qualification: this.qualification,
				institution: this.collegeuniversity,
				year_qualified: this.parseDateToServerFormat(this.dateFormatted),
				other_qualifications: this.otherqualifications,
			};

			// if (body.other_qualifications?.length > 2) {
			// 	store.commit('SET_PROFILE_BUTTON_TO_POSITIVE', 'education-step');
			// } else if (body.other_qualifications === '') {
			// 	store.commit('SET_PROFILE_BUTTON_TO_NEGATIVE', 'education-step');
			// }
			store.commit('SET_PROFILE_BUTTON_TO_POSITIVE', 'education-step');

			try {
				const response = await axios.put(store.getters.getAPI + '/professionals/qualification', body, { headers: { Authorization: token } });

				bus.$emit('form-submitted', { form: this.name, status: response.status });

				if (response.status === 200) {
					store.commit('SET_USER', response.data.data); //updates the users state locally.
					bus.$emit('intent:next-step', 'education-step');
				}
			} finally {
				bus.$emit('update:spinning', false);
			}
		},

		SubmitForm() {
			let valid = this.validate();

			if (valid) {
				bus.$emit('intent:submit-forms:' + this.name);
			}
		},

		formatDate,

		formatDateFromServer(date) {
			if (!date) return null;

			const [month, day, year] = date.split('/');
			return `${day.padStart(2, '0')}/${month.padStart(2, '0')}/${year}`;
		},

		parseDate(date) {
			if (!date) return null;

			const [day, month, year] = date.split('/');
			return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
		},

		parseDateFromServerFormat(date) {
			if (!date) return null;

			const [month, day, year] = date.split('/');
			return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
		},

		parseDateToServerFormat(date) {
			if (!date) return null;

			const [day, month, year] = date.split('/');
			return `${month.padStart(2, '0')}/${day.padStart(2, '0')}/${year}`;
		},
	},
};
</script>
